import { render, staticRenderFns } from "./AdditionalRequirementsMenu.vue?vue&type=template&id=63126131&scoped=true&"
import script from "./AdditionalRequirementsMenu.vue?vue&type=script&lang=js&"
export * from "./AdditionalRequirementsMenu.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalRequirementsMenu.vue?vue&type=style&index=0&id=63126131&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63126131",
  null
  
)

export default component.exports